<template>
  <div>
    <template v-if="detalhes && detalhes.length > 0">
      <div class="table-outer-title font-weight-bold text-uppercase text-center">
        Detalhes — Outros Correlatos
      </div>
      <div class="table-container">
        <table>
          <tr>
            <th>Descrição</th>
            <th>Justificativa</th>
            <th>Valor</th>
          </tr>
          <tr v-for="(d, i) in detalhes" :key="i">
            <td>{{ d.descricao }}</td>
            <td>{{ d.justificativa }}</td>
            <td>{{ d.valor | toCurrency }}</td>
          </tr>
          <tr class="font-weight-bold">
            <td colspan="2">Total</td>
            <td>{{ totalOutros | toCurrency }}</td>
          </tr>
        </table>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "DetalhesOutros",
  props: {
    detalhes: {
      type: Array,
      default: function () { return []; },
    },
  },
  computed: {
    totalOutros() {
      return this.detalhes.reduce(function (sum, d) { return sum + (d.valor || 0); }, 0);
    },
  },
};
</script>

<style lang="scss" scoped src="../styles/report.scss"></style>
